import { useMemo } from "react";
import { useLocation } from "react-router";

import type { ISignUpCampaignMetadata } from "~/feature/auth/type";
import { resolveSignUpCampaign } from "~/feature/auth/utils/resolveSignUpCampaign";

export const useSignUpUnsafeMetadata = ():
  | ISignUpCampaignMetadata
  | undefined => {
  const { pathname, search } = useLocation();
  const signupCampaign = resolveSignUpCampaign(
    pathname,
    new URLSearchParams(search)
  );

  return useMemo(
    () => (signupCampaign ? { signupCampaign } : undefined),
    [signupCampaign]
  );
};
